// src/pages/GoalsPage.js
import React from "react";
import EvaluationDashboardView from "../components/EvaluationDashboardView/EvaluationDashboardView"
import NavBar from "../components/NavBar/NavBar";

export default function AccountPage() {
  return (
    <>
      <NavBar/>
      <main className="web-view">
        <EvaluationDashboardView/>
      </main>
    </>
  );
}